<template>
  <div class="avatar-box ma-1">
    <div class="avatar-icon" data-cy="avatarIcon-avatar-image">
      <img
        :src="`${$utils.globalConstants.BASE_ASSETS_URL}/avatar/${avatar.name}/${avatar.value}`"
        class="transition-all"
        id="main-avatar"
        alt="Avatar"
        :height="height ? height : 40"
        :width="width ? width : 40"
      />
    </div>
  </div>
</template>

<script>
import { DEFAULT_AVATAR } from "@/constants/DefaultConstants"
import global from "@/constants/GlobalConstant"

export default {
  props: {
    avatar: {
      type: Object,
      default: DEFAULT_AVATAR,
    },
    height: Number,
    width: Number
  },
  data() {
    return {
      timer: null,
    }
  },
  mounted() {
    const vm = this
    this.timer = setInterval(() => {
      vm.avatarUrl()
    }, 5000)
  },
  methods: {
    avatarUrl() {
      const avatarImg = document.querySelector('#main-avatar')
      if (avatarImg)
        avatarImg.setAttribute(
          'src',
          `${this.$utils.globalConstants.BASE_ASSETS_URL}/avatar/${this.avatar.name}/${this.avatar.value}`
        )
    },
  },
  beforeDestroy() {
    clearInterval(this.timer)
  },
}
</script>

<style lang="scss" scoped>

.avatar-box{
  background: #AEECB426;
}
.avatar-box img{
  border-radius: 100%;
}
.avatar-icon{
  position: relative;
}

</style>
